export const InterpolationType = {
  NEAREST: 0,
  LINEAR: 1,
  FAST_LINEAR: 2,
};

export const OpacityMode = {
  FRACTIONAL: 0,
  PROPORTIONAL: 1,
};

export const ColorMixPreset = {
  DEFAULT: 0,
  ADDITIVE: 1,
  COLORIZE: 2,
  CUSTOM: 3,
};

export const FilterMode = {
  OFF: 0,
  NORMALIZED: 1,
  RAW: 2,
};

export default {
  InterpolationType,
  OpacityMode,
  ColorMixPreset,
  FilterMode,
};
